(function ($){

    // Text in headers
    var header = TweenMax.to(".header-content h1, " +
        ".views-field-field-title-in-header h1, " +
        "#block-titelwinkelsoverzichtspagina h1," +
        "header.overview-header h1, " +
        ".search-view .view-header h1," +
        ".search-view .view-empty h1",
        1,
        { opacity: 1, delay: 0.6, y: "0px", ease: Sine.easeOut});


  Drupal.behaviors.winkelstad = {
    attach: function (context, settings) {
      attachHandlers();
    }
  };

}(jQuery));



const config = {
  threshold: 0.1
};

const tl = new TimelineMax()

let observer = new IntersectionObserver(function(entries, self) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      let overlap = '-=0.3';

      if (!tl.isActive()) {
        overlap = '+=0';
      }

      tl.to(entry.target, 0.5, { autoAlpha: 1 }, overlap);
      self.unobserve(entry.target);
    }
  });
}, config);

function attachHandlers() {
  // observer testing
  const boxes = document.querySelectorAll('.card-wrapper');

  jQuery('.view-winkelkaart .views-row').on('click', function(e){
    window.location = jQuery(this).find('h3 a').attr('href');
  }).addClass('clickable');

  boxes.forEach(box => {
    observer.observe(box);
  });
}

const vid = document.getElementById("header-video");
if(vid) {
  vid.style.opacity = '0';

  vid.addEventListener('canplaythrough', (event) => {
    fade(vid);
  });
}


function fade(element) {
  let op = 0;
  const timer = setInterval(function () {
    if (op >= 1) clearInterval(timer);
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
    op += op * 0.1 || 0.1;
  }, 50);
}

window.addEventListener('load', function(event) {
  attachHandlers();
});

